<template>
  <div class="info">
    <lb-table
      v-loading="loading"
      v-horizontal-scroll="'always'"
      :column="columns"
      :data="page.list"
      pagination
      :total="page.totalNum"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="[5, 10, 20, 30, 50]"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      @selection-change="onMultipleSelection"
      @size-change="handleSizeChange"
      @p-current-change="handleCurrentChange"
    >
    </lb-table>
  </div>
</template>
<script>
import LbTable from '../../../components/lb-table/lb-table'
export default {
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  components: {
    LbTable
  },
  data () {
    return {
      loading: true,
      name: 'cdd',
      list: [{
        name: 'cdd'
      },
      {
        name: 'cdd'
      }, {
        name: 'cdd'
      }, {
        name: 'cdd'
      }
      ],
      columns: [
        { label: '收货人姓名', prop: 'name', minWidth: '120' },
        { label: '收货人电话', prop: 'phone', minWidth: '220' },
        {
          label: '省/市/区', prop: 'brandName', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                {scope.row.provinceName}{scope.row.cityName}{scope.row.districtName}
              </div>
            )
          }
        },
        { label: '详细地址', prop: 'address', minWidth: '120' },
        {
          label: '是否为默认地址', prop: 'isDefault', minWidth: '120',
          render: (h, scope) => {
            return (
              <div>
                <p>{scope.row.isDefault == 1 ? '是' : '否'}</p>
              </div>
            )
          }

        }
      ],
      page: { list: [], pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' }
    }
  },
  watch: {
    id (val, vall) {
      this.id = val
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    onMultipleSelection (val) {
      this.selectionGoods = val
    },
    handleCurrentChange (currentChange) {
      this.page.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange (sizeChange) {
      this.page.pageSize = sizeChange
      this.fetchData()
    },
    fetchData () {
      let data = {
        userId: this.id,
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize
      }
      this.$api.getAddressPageList(data).then(res => {
        this.page.list = res.data.list
        this.page.totalNum = res.data.totalNum
        this.loading = false
      })
    }
  }
}
</script>
<style scoped>
.info {
  padding-top: 20px;
  padding-bottom: 20px;
}
</style>

